import React from 'react';
import {Trans, useTranslation} from 'react-i18next';

import {
    Bar,
    Button,
    FontVariant,
    Form,
    Text,
    TextHeading,
} from '@pexip/components';

import {TestId} from '../../../test/testIds';

export const RegistrationExpired: React.FC<{
    onReRegister: () => void;
    onSignOut: () => void;
    isLoading: boolean;
}> = ({onReRegister, onSignOut, isLoading}) => {
    const {t} = useTranslation();

    return (
        <>
            <TextHeading
                htmlTag="h2"
                fontVariant={FontVariant.H2}
                className="mb-2"
            >
                <Trans t={t} i18nKey="register.expired-title">
                    Session expired
                </Trans>
            </TextHeading>
            <Text>
                <Trans t={t} i18nKey="register.expired-description">
                    Your session has expired. Please sign in again to continue
                    receiving calls.
                </Trans>
            </Text>
            <Form
                onSubmit={(event: React.FormEvent<HTMLFormElement>) => {
                    event.preventDefault();
                    onReRegister();
                }}
            >
                <Bar>
                    <Button
                        modifier="fullWidth"
                        type="submit"
                        size="large"
                        isLoading={isLoading}
                        data-testid={TestId.ButtonRegistrationReRegister}
                        className="mt-3"
                    >
                        <Trans t={t} i18nKey="register.expired-sign-in">
                            Sign in
                        </Trans>
                    </Button>
                </Bar>
                <Bar>
                    <Button
                        modifier="fullWidth"
                        type="button"
                        size="large"
                        variant="dangerBordered"
                        isDisabled={isLoading}
                        onClick={onSignOut}
                        data-testid={TestId.ButtonRegistrationSignOut}
                        className="mt-2"
                    >
                        {t('register.sign-out', 'Sign out')}
                    </Button>
                </Bar>
            </Form>
        </>
    );
};
